export interface ContextRouterState {
  urlKey: string;
  sessionId: string;
  authKey: string;
  opcoTheme: string;
  hasError: boolean;
  loading: boolean;
  loaded: boolean;
  blobResponse: any;
}

export enum ContextRouterActions {
  VALIDATE_CONTEXT_ROUTER = 'VALIDATE_CONTEXT_ROUTER',
  VALIDATE_CONTEXT_ROUTER_SUCCESS = 'VALIDATE_CONTEXT_ROUTER_SUCCESS',
  VALIDATE_CONTEXT_ROUTER_FAIL = 'VALIDATE_CONTEXT_ROUTER_FAIL',
  UPDATE_CONTEXT_ROUTER_AUTHKEY = 'UPDATE_CONTEXT_ROUTER_AUTHKEY',
  SET_OPCO_THEME = 'SET_OPCO_THEME',
}

interface ContextRouterType<T, P> {
  type: T;
  payload: P;
}

export type ContextRouterAction =
  | ContextRouterType<typeof ContextRouterActions.VALIDATE_CONTEXT_ROUTER, { urlKey: string; authKey: string }>
  | ContextRouterType<typeof ContextRouterActions.VALIDATE_CONTEXT_ROUTER_SUCCESS, any>
  | ContextRouterType<typeof ContextRouterActions.VALIDATE_CONTEXT_ROUTER_FAIL, string>
  | ContextRouterType<typeof ContextRouterActions.UPDATE_CONTEXT_ROUTER_AUTHKEY, any>
  | ContextRouterType<typeof ContextRouterActions.SET_OPCO_THEME, any>;

export const initialContextRouterState: ContextRouterState = {
  urlKey: '',
  authKey: '',
  sessionId: '',
  opcoTheme: '',
  hasError: false,
  loading: false,
  loaded: false,
  blobResponse: null,
};
